import type { Discount } from '@carvana/merch-contracts';
import DiscountType from '@carvana/merch-contracts/DiscountType';
import { useMemo } from 'react';
import { useConfiguration } from '~/context/common/StaticContext';
import { useInventoryVehicles } from '~/context/srp/InventoryContext';

export default function useGetRootDiscount(): Discount | null {
  const { enableRootDiscount = false } = useConfiguration();
  const vehicles = useInventoryVehicles();

  return useMemo<Discount | null>(
    () =>
      enableRootDiscount
        ? vehicles
            .at(0)
            ?.price?.discounts?.find(
              discount => discount.type === DiscountType.RootTotalLoss
            ) ?? null
        : null,
    [enableRootDiscount, vehicles]
  );
}
